import styled from 'styled-components';

const LoadingModal = () => {
    return (
        <Wrap className='flex aic jcc'>
            <div className="spinner"></div>
        </Wrap>
    );
}

export default LoadingModal;

const Wrap = styled.div`
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5;

    .spinner {
        width: 48px;
        height: 48px;
        border: 5px solid #f3f3f3;
        border-top: 5px solid ${props => props.theme.mainColor1};
        border-radius: 50%;
        animation: spin 1s linear infinite;
        @media (max-width: 767px) {
            width: 40px;
            height: 40px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid ${props => props.theme.mainColor1};
        }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`